// #ux-redesign-start: definicion de secciones del sidebar (Paso 3)
// Lookup section_key -> { i18n_label, order }.
// Las rutas declaran `section: 'hub'` en routes.js y el Sidebar agrupa por
// este lookup.
//
// PORTABILIDAD: trasplantable a Web-Patients. Las claves i18n viven en el
// namespace 'sidebar' de cada idioma.
// ─────────────────────────────────────────────────────────────────────────────

export const SECTIONS = [
  { key: 'hub',           order: 1, i18nKey: 'section-hub' },
  { key: 'communication', order: 2, i18nKey: 'section-communication' },
  { key: 'clinical',      order: 3, i18nKey: 'section-clinical' },
  { key: 'practice',      order: 4, i18nKey: 'section-practice' },
  { key: 'account',       order: 5, i18nKey: 'section-account' },
  { key: 'other',         order: 99, i18nKey: 'section-other' }, // catch-all
];

export const getSectionByKey = (key) =>
  SECTIONS.find((s) => s.key === key) || SECTIONS.find((s) => s.key === 'other');

// Agrupa rutas por section, retorna [{ section, routes: [...] }, ...] ordenado.
// Las rutas sin `section` caen en 'other' al final.
export const groupRoutesBySection = (routes) => {
  const groups = {};
  for (const route of routes) {
    const key = route.section || 'other';
    if (!groups[key]) groups[key] = [];
    groups[key].push(route);
  }
  return SECTIONS
    .filter((s) => groups[s.key] && groups[s.key].length > 0)
    .map((s) => ({ section: s, routes: groups[s.key] }));
};

// #ux-redesign-end
